import { useQuery } from '@tanstack/react-query'
import { fetchRecentArticles } from '../service/guide.service'
import { Article } from '@app/components/Guide/types/guide.types'

export const useRecentArticles = () => {
  return useQuery<Article[]>({
    queryKey: ['recent-articles'],
    queryFn: fetchRecentArticles,
  })
}
